(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/deposit-block/deposit-restrictions-first-dialog.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/deposit-block/deposit-restrictions-first-dialog.js');

'use strict';

const {
  ReactIcon: Icon
} = svs.ui;
const {
  ReactButton: Button
} = svs.ui;
const {
  RadioGroup
} = svs.ui.reactForm;
const {
  RadioButton
} = svs.ui.reactForm;
const {
  putDepositAmount
} = svs.accountservicesReact.deposit.services.depositService;
const {
  showSetDepositTimesDialog,
  showSetDepositTimesSucessDialog,
  generalErrorDialog
} = svs.accountservicesReact.deposit.dialogs.blockInfoDialogs;
const DepositRestrictionsFirstDialog = _ref => {
  var _blockInfo$depositRes;
  let {
    blockInfo,
    setIsCheckBlock
  } = _ref;
  const [showMore, isShowMore] = React.useState(false);
  const [depositTimesChoice, setDepositTimesChoice] = React.useState(null);
  const convertDepositAmount = {
    1: 'en',
    2: 'två',
    3: 'tre',
    4: 'fyra',
    5: 'fem'
  };
  const setDepositAmount = async depositTimesChoice => {
    const putDepositAmountResponse = await putDepositAmount(depositTimesChoice);
    if (putDepositAmountResponse !== null && putDepositAmountResponse !== void 0 && putDepositAmountResponse.error) {
      generalErrorDialog();
    } else {
      switch (depositTimesChoice) {
        case 0:
          showSetDepositTimesSucessDialog('Du kommer inte att kunna göra fler insättningar idag');
          break;
        case 1:
          showSetDepositTimesSucessDialog('Du kommer inte att kunna göra fler insättningar idag');
          break;
        default:
          showSetDepositTimesSucessDialog("Du kommer att kunna g\xF6ra ".concat(convertDepositAmount[depositTimesChoice], " ins\xE4ttningar till idag"));
          break;
      }
      setIsCheckBlock(true);
    }
  };
  const submitDepositTimes = async () => {
    switch (depositTimesChoice) {
      case 0:
        if (await showSetDepositTimesDialog('Vill du begränsa dina insättningar helt idag?')) {
          setDepositAmount(depositTimesChoice);
        }
        break;
      case depositTimesChoice:
        if (await showSetDepositTimesDialog("Vill du begr\xE4nsa dina ins\xE4ttningar till ".concat(convertDepositAmount[depositTimesChoice], " idag?"))) {
          setDepositAmount(depositTimesChoice);
        }
        break;
      default:
        generalErrorDialog();
        break;
    }
  };
  return React.createElement("div", {
    className: "f-body line-height-150"
  }, React.createElement("div", {
    className: "padding-v-2 align-center"
  }, React.createElement(Icon, {
    icon: "help",
    size: "700"
  })), React.createElement("div", {
    className: "f-center"
  }, React.createElement("h2", {
    className: "h2 margin-v-1 line-height-120-override"
  }, "Hur m\xE5nga fler ins\xE4ttningar vill du kunna g\xF6ra idag?"), React.createElement("p", {
    className: "margin-0 padding-bottom-2"
  }, "Du har gjort", ' ', (blockInfo === null || blockInfo === void 0 || (_blockInfo$depositRes = blockInfo.depositRestrictions) === null || _blockInfo$depositRes === void 0 ? void 0 : _blockInfo$depositRes.depositsMade) === 2 ? 'två' : 'tre', ' ', "ins\xE4ttningar idag. Genomsnittet \xE4r en g\xE5ng per dag.")), showMore && React.createElement(RadioGroup, {
    multipleLines: true,
    size: 200
  }, React.createElement(RadioButton, {
    minWidth: "50%",
    onChange: () => setDepositTimesChoice(0),
    value: "0"
  }, "INGA FLER"), React.createElement(RadioButton, {
    minWidth: "50%",
    onChange: () => setDepositTimesChoice(1),
    value: "1"
  }, "1"), React.createElement(RadioButton, {
    minWidth: "50%",
    onChange: () => setDepositTimesChoice(2),
    value: "2"
  }, "2"), React.createElement(RadioButton, {
    minWidth: "50%",
    onChange: () => setDepositTimesChoice(3),
    value: "3"
  }, "3"), React.createElement(RadioButton, {
    minWidth: "50%",
    onChange: () => setDepositTimesChoice(4),
    value: "4"
  }, "4"), React.createElement(RadioButton, {
    minWidth: "50%",
    onChange: () => setDepositTimesChoice(5),
    value: "5"
  }, "5")), !showMore && React.createElement(React.Fragment, null, React.createElement(RadioGroup, {
    multipleLines: true,
    size: 200
  }, React.createElement(RadioButton, {
    minWidth: "50%",
    name: "deposit-question-basic",
    onChange: () => setDepositTimesChoice(0),
    value: "0"
  }, "INGA FLER"), React.createElement(RadioButton, {
    minWidth: "50%",
    name: "deposit-question-basic",
    onChange: () => setDepositTimesChoice(1),
    value: "1"
  }, "1")), React.createElement("div", {
    className: "padding-top-1"
  }, React.createElement(Button, {
    block: true,
    onClick: isShowMore,
    transparent: true
  }, "Visa fler alternativ"))), React.createElement("div", {
    className: "padding-top-1"
  }, React.createElement(Button, {
    block: true,
    disabled: depositTimesChoice === null,
    inverted: true,
    onClick: submitDepositTimes
  }, "Okej")));
};
svs.accountservicesReact.deposit.depositBlock.DepositRestrictionsFirstDialog = DepositRestrictionsFirstDialog;

 })(window);